import { ModelBase } from 'store/model-base';

export class CmsEsimDownload extends ModelBase {
    public static storeName: string = 'cmsEsimDownload';
    
    public esimDownloadHeader: string;
    public esimNewDeviceIcon: CmsMediaImage;
    public esimNewDevice: esimDeviceDetails;
    public esimDifferentDeviceIcon: CmsMediaImage;
    public esimDifferentDevice: esimDeviceDetails;
    public esimDownloadConfirmation: EsimDownloadConfirmation;
    public esimDownloadFailed: CmsEsimDownloadFailed;
}
